__turbopack_context__.v({
  "clearButton": "F-L0BW_clearButton",
  "form": "F-L0BW_form",
  "root": "F-L0BW_root",
  "searchButton": "F-L0BW_searchButton",
});
